import React from "react";

// material ui
import { FormControl, Select, MenuItem, InputLabel } from "@material-ui/core";

// component
import LoadingElements from "components/Loading/LoadingElements";

// style
import styles from "./Form.module.scss";

const Country = ({
  handleChange = null,
  array = null,
  value = null,
  name = null,
  required = false,
  label = "default",
  disabled = false,
}) => {
  return (
    <FormControl
      variant="outlined"
      required={required}
      fullWidth
      className={styles["form-control"]}
    >
      <InputLabel
        className={styles["form-label"]}
        shrink={true}
        disableAnimation={true}
        htmlFor={`${name}-helper`}
        id="demo-simple-select-outlined-label"
      >
        {label}
      </InputLabel>
      {array === null && (
        <LoadingElements className={styles["form-load-elements"]} />
      )}
      {array !== null && (
        <Select
          className={styles["form-input"]}
          id={`${name}-helper`}
          value={value === null ? "" : value}
          onChange={handleChange}
          displayEmpty
          disabled={disabled}
        >
          {array.map((val, index) => {
            return (
              <MenuItem key={index} value={val.Country__}>
                {val.Name}
              </MenuItem>
            );
          })}
        </Select>
      )}
    </FormControl>
  );
};

export default Country;
